import { HoldBestAvailableSeatsInput, CreateOrderInput } from "~graphql/sdk";
import { getError, handlePromise, sdk, showToast } from "~lib";

export const holdSeats = async (
  orgId: string,
  input: HoldBestAvailableSeatsInput
) => {
  const { data, error } = await handlePromise(async () =>
    sdk({ orgId }).holdBestAvailableSeats({ input })
  );

  if (error) {
    let errorMsg = getError(error, "graphQL");

    if (errorMsg?.toLowerCase().includes("best available objects not found")) {
      errorMsg = "No seats available in section";
    }
    showToast(errorMsg, "error");
    return false;
  }

  return data;
};

export const createOrder = async (
  sdkFn: typeof sdk,
  orgId: string,
  input: CreateOrderInput
) => handlePromise(async () => sdkFn({ orgId }).createOrder({ input }));
